import * as React from 'react';
import cx from 'classnames';

import style from './style.module.scss';

interface CardProps {
  children: any;
  className?: string;
  shadow?: boolean;
}

export default function Card({ children, className, shadow }: CardProps) {
  return (
    <div className={cx(style.cardContainer, className, { [style.boxShadow]: shadow })}>
      {children}
    </div>
  );
}
